<template>
    <div class="l-ss-c-search-results-wrapper">
        <div
            class="l-ss-c-search-popup-content"
            :class="{
                'l-ss-c-filters-left': filterPositionLeft,
                'l-ss-c-search-popup-content-masked': showMask
            }">
            <popup
                :opened="store.state.ui.isFiltersOpened"
                :show-close-icon="false"
                class="l-ss-c-search-popup-filters-popup"
                @close="() => toggleFilters(false)">
                <section-full-filters
                    :filters="filterItems"
                    :has-results="hasResults"
                    :has-selected="hasFilters"
                    :total-items-count="totalItemsCount"
                    :values="filterValues"
                    :all-categories-list="allCategoriesList"
                    :all-categories-tree="allCategoriesTree"
                    :currency="currencyInOffers"
                    :loading-by-filters="loadingByFilters"
                    @filters-change="onFilterChange"
                    @filter-click="params => $emit('filter-click', params)"
                    @close="() => toggleFilters(false)"
                    @reset="() => $emit('reset-filters')"/>
            </popup>
            <div
                v-if="isShowResultsLoader"
                class="l-ss-c-results-loader">
                <pulse-dots/>
            </div>

            <template v-else>
                <div class="l-ss-c-image-search-similar-wrapper-close-button">
                    <i
                        class="l-ss-c-search-input-icon l-ss-c-search-input-icon-close"
                        @click="() => $emit('click-close', { type: 'click-close' })"
                        v-html="iconClose"></i>
                </div>
                <section-results-info
                    v-if="isResultsVisible && totalItemsCount"
                    :search="search"
                    :total-items-count="totalItemsCount"
                    @autocomplete-search="onAutocompleteSearch"
                    @params-search="$emit('params-search', $event)"
                    @result-tab-click="$emit('result-tab-click', $event)"
                    @handle-tags-click="onTapAction"/>

                <div :class="{ 'l-ss-c-filters-left-container': filterPositionLeft }">
                    <section-filters
                        v-if="showFilters"
                        ref="sectionFilters"
                        :currency="currencyInOffers"
                        :filter-position-left="filterPositionLeft"
                        :filters="filterItems"
                        :has-results="hasResults"
                        :has-selected="hasFilters"
                        :show-sorting="showSorting"
                        :sort-by="sortBy"
                        :sort-dest="sortDest"
                        :total-items-count="totalItemsCount"
                        :values="filterValues"
                        :all-categories-list="allCategoriesList"
                        :is-show-signature="isShowSignature"
                        :store="store"
                        :base64-image="base64Image"
                        :base64-image-key="base64ImageKey"
                        search-type="search-results"
                        class="l-ss-c-search-popup-content-wrapper-child"
                        @search-image="$emit('search-image', { base64: $event })"
                        @replace-image="toggleImagePicker"
                        @filters-change="onFilterChange"
                        @filter-click="params => $emit('filter-click', params)"
                        @sort-change="params => $emit('sort-change', params)"
                        @result-sort-click="params => $emit('result-sort-click', params)"
                        @reset-filters="() => $emit('reset-filters')"
                        @close-filters="() => toggleFilters(false)"
                        @open-filters="() => toggleFilters(true)"/>
                    <section-results
                        v-if="isResultsVisible"
                        ref="search-results"
                        :categories="allCategoriesList"
                        :all-categories-tree="allCategoriesTree"
                        :category-id="resultsCategoryId"
                        :store="store"
                        :error-text="requestErrorText"
                        :filter-position-left="filterPositionLeft"
                        :filters="filterItems"
                        :filter-values="filterValues"
                        :group-categories="$configuration.features.shouldGroupCategories"
                        :has-filters="hasFilters"
                        :has-loaded-once="hasLoadedOnce"
                        :has-query="hasQuery"
                        :has-results="hasResults"
                        :is-loading="isLoading"
                        :loading-by-filters="loadingByFilters"
                        :loading-next-page="loadingNextPage"
                        :limit="limit"
                        :currency="currencyInOffers"
                        :search="searchResponse"
                        :search-request-id="searchRequestId"
                        :search-state="searchState"
                        :skip="skip"
                        :templates="offerTemplates"
                        :total-items-count="totalItemsCount"
                        :query="query"
                        :sort-by="sortBy"
                        :sort-dest="sortDest"
                        :show-sorting="showSorting"
                        :adult-permission-confirmed="adultPermissionConfirmed"
                        :is-show-signature="isShowSignature"
                        class="l-ss-c-search-popup-content-wrapper-child"
                        @sort-change="$emit('sort-change', $event)"
                        @filters-change="onFilterChange"
                        @result-sort-click="$emit('result-sort-click', $event)"
                        @autocomplete-search="onAutocompleteSearch"
                        @navigate-category="params => $emit('navigate-category', params)"
                        @navigate-page-next="handleNavigatePageNext"
                        @navigate-page-prev="() => $emit('navigate-page-prev')"
                        @reset-category="onResetCategory"
                        @offer-click="params => $emit('offer-click', params)"
                        @add-to-cart-click="params => $emit('add-to-cart-click', params)"
                        @add-to-cart="args => $emit('add-to-cart', args)"
                        @reset-filters="() => $emit('reset-filters')"
                        @reset-query="() => $emit('reset-query')"
                        @handle-tags-click="(value) => onTapAction(value)"
                        @result-tab-click="(value) => $emit('result-tab-click', value)"
                        @result-category-click="(value) => $emit('result-category-click', value)"
                        @view-in-category-click="(value) => $emit('view-in-category-click', value)"
                        @page-reload="params => $emit('page-reload', params)"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import SectionResults from '@/core/components/section-results/section-results.vue';
    import SectionFilters from '@/core/components/filters/section-filters';
    import Popup from '@/core/components/popup';
    import SectionFullFilters from '@/core/components/filters/section-full-filters';
    import ClickOutside from '@/core/directives/clickOutside.js';
    import store from '@/core/store';
    import PulseDots from '@/core/components/pulse-dots.vue';
    import SectionResultsInfo from '@/core/components/section-results/section-results-info.vue';
    import closeIcon from '@/core/assets/images/icons/close.svg';

    export default {
        components: {
            SectionResultsInfo,
            PulseDots,
            SectionFilters,
            SectionResults,
            Popup,
            SectionFullFilters,
        },
        directives: {
            'click-outside': ClickOutside,
        },
        props: {
            search: {
                type: Object,
                required: false,
                default: () => null,
            },
            filterValues: {
                type: Array,
            },
            currencyInOffers: {
                type: String,
                default: '',
            },
            sortDest: {
                type: String,
                default: '',
            },
            sortBy: {
                type: String,
                default: '',
            },
            isShowSort: {
                type: Boolean,
                default: true,
            },
            filterItems: {
                type: Array,
            },
            offerTemplates: {
                type: Object,
                required: false,
            },
            skip: {
                type: [Number, String],
                default: '',
            },
            searchRequestId: {
                type: String,
                default: '',
            },
            searchResponse: {
                type: Object,
                required: false,
                default: () => null,
            },
            limit: {
                type: Number,
                default: 0,
            },
            isSearchLoading: {
                type: Boolean,
                default: false,
            },
            isCompletionsLoading: {
                type: Boolean,
                default: false,
            },
            loadingByFilters: {
                type: Boolean,
                default: false,
            },
            hasResults: {
                type: Boolean,
                default: false,
            },
            hasQuery: {
                type: Boolean,
                default: false,
            },
            hasLoadedOnce: {
                type: Boolean,
                default: false,
            },
            showResultsMask: {
                type: Boolean,
                default: false,
            },
            hasFilters: {
                type: Boolean,
                default: false,
            },
            errorTextCompletions: {
                type: String,
                default: '',
            },
            errorTextSearch: {
                type: String,
                default: '',
            },
            resultsCategoryId: {
                type: [String, Number, Array],
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
            isFiltersBlockVisible: {
                type: Boolean,
                default: false,
            },
            isResultsVisible: {
                type: Boolean,
                default: false,
            },
            totalItemsCount: {
                type: Number,
                default: 0,
            },
            query: {
                type: String,
                default: '',
            },
            searchState: {
                type: Object,
                default: () => ({
                    public: {},
                    private: {},
                }),
            },
            store: {
                required: true,
                type: Object,
                default: () => store,
            },
            isShowSignature: {
                type: Boolean,
                default: false,
            },
            adultPermissionConfirmed: {
                type: Boolean,
                default: false,
            },
            allCategoriesTree: {
                type: Array,
            },
        },
        data() {
            return {
                base64ImageKey: false,
                prevSearchResponse: [],
                loadingNextPage: false,
            };
        },
        computed: {
            iconClose() {
                return closeIcon;
            },
            filterPositionLeft() {
                return this.$configuration.layout.filterPosition === 'left' && !this.$screen.isMobile && this.totalItemsCount >
                    0;
            },
            requestErrorText() {
                return this.errorTextCompletions || this.errorTextSearch || '';
            },
            isCategoriesLoading() {
                return this.requestCategories ? this.requestCategories.isLoading : false;
            },
            isLoading() {
                return this.isCompletionsLoading || this.isSearchLoading || this.isCategoriesLoading;
            },
            categoriesResponse() {
                return this.requestCategories ? this.requestCategories.response : null;
            },
            allCategoriesList() {
                return this.categoriesResponse || [];
            },
            showSorting() {
                return (Boolean(this.hasResults) && this.isShowSort);
            },
            hasImageSearchResults() {
                return Boolean(this.searchState.private && this.searchState.private.image);
            },
            image() {
                return this.hasImageSearchResults ? this.searchState.private.image : '';
            },
            isShowResultsLoader() {
                if (this.loadingByFilters || this.loadingNextPage || !this.isSearchLoading) {
                    return false;
                }

                return this.isSearchLoading || (!this.isResultsVisible && this.hasResults);
            },
            showMask() {
                return this.showResultsMask || this.store.state.ui.isImageSearchVisible || this.store.state.ui.isVoiceSearchActive;
            },
            base64Image() {
                return this.store.state.base64Image;
            },
            showFilters() {
                return this.isFiltersBlockVisible && this.isResultsVisible;
            },
            isShowImageSearchInFilters() {
                return this.$configuration.isShowImageSearchInFilters && this.$configuration.layout.filterPosition === 'left';
            },
        },
        watch: {
            'searchState.public': function (state) {
                if (state.query) {
                    this.resetImage();
                }
            },
            base64Image() {
                this.base64ImageKey = !this.base64ImageKey;

                if (this.isShowImageSearchInFilters) {
                    this.onImageSearch(this.base64Image);
                }
            },

            searchResponse(newSearchResponse, prevSearchResponse) {
                this.prevSearchResponse = prevSearchResponse;
            },

            isLoading(value) {
                if (!value) {
                    this.loadingNextPage = false;
                }
            },
        },
        mounted() {
            const instances = this.$instances.filter(item => item.type === 'image-search-similar');
            let offerId = null;
            let fields = null;
            if (instances && instances.length) {
                if (instances[0].searchToParams) {
                    ({ offerId, fields } = instances[0].searchToParams);
                    if (!offerId) {
                        offerId = this.getOfferIdDefaultSchema;
                    }
                    this.setSearchToParams(offerId(), fields);
                }
            }
        },
        methods: {
            setSearchToParams(offerId, fields = [{ name: 'category' , condition: 'in', key: 'categories' }]) {
                if (!offerId) {
                    return;
                }
                const data = window.searchbooster.api.controller.handleFindById(offerId);
                data.then(data => {
                    let fieldValue = null;
                    let output = [];
                    fields.forEach(field => {
                        if (typeof data.offer[field.key] === 'object') {
                            fieldValue = data.offer[field.key].map(item => item.id);
                        } else {
                            fieldValue = [data.offer[field.key]];
                        }
                        let params = {
                            field: field.name,
                            condition: field.condition,
                            options: fieldValue,
                        };

                        if (field.condition === 'range') {
                            delete params.options;
                            params.min = fieldValue[0];
                            params.max = fieldValue[0];
                        }
                        output.push(params);
                        this.$emit('filters-change', { filters: output, changed: [field.name] });
                    });
                });
            },
            onTapAction(value) {
                this.$emit('search-input-change', { query: value, focus: false });
                this.$emit('handle-search');
            },
            toggleFilters(value) {
                this.$emit('toggle-filters', value);
            },
            resetImage() {
                this.store.commit('base64Image/SET_PROPERTY', null);
            },
            onImageSearch(image) {
                this.$emit('search-image', { base64: image });
            },
            onResetCategory() {
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategorySearch', value: false });
                this.emitNavigateCategory({ skip: 0, categoryId: '' });
            },
            onAutocompleteSearch(value) {
                this.$emit('autocomplete-search', value);
            },
            getOfferIdDefaultSchema() {
                if (!window.dataLayer) {
                    return null;
                }
                const dataLayerOffers = window.dataLayer.filter((item) => item.ecommerce?.detail?.products);
                let id = null;
                if (dataLayerOffers && dataLayerOffers.length > 0) {
                    id = dataLayerOffers[0].ecommerce?.detail?.products[0]?.id;
                }
                return id;
            },
            onFilterChange({ field, ...params }) {
                let allowedFilters = [];

                if (this.filterItems.length) {
                    allowedFilters = this.filterItems.map(filter => filter.name);
                } else {
                    allowedFilters = this.prevSearchResponse?.params.map(filter => filter.name) || [];
                }

                const hasParams = !!Object.keys(params).length;
                const output = this.filterValues
                    .filter(filter => filter.field !== field && allowedFilters.includes(filter.field))
                    .slice(0);

                if (allowedFilters.includes(field) && hasParams) {
                    output.push({ field, ...params });
                }

                this.$emit('filters-change', { filters: output, changed: [field] });
            },
            handleNavigatePageNext() {
                this.loadingNextPage = true;
                this.$emit('navigate-page-next');
            },
            toggleImagePicker(event) {
                this.$emit('toggle-image-picker');
                this.$emit('button-image-click', { type: 'buttonImageClick', event });
            },
        },
    };
</script>
